/**
 * @name AuthService
 * @description Servicio para la autenticación de usuario (Login y Logout)
 * @author Ricardo Guerra
 */

import axios from 'axios';
import moment from 'moment';
import { Environment } from '@config';

const authData = JSON.parse(localStorage.getItem('ls.authorizationData'));

// Información de autenticación
let authentication = {
  isAuth: (authData && authData.expirationDate && (new Date() < new Date(authData.expirationDate))) || false
};

// URL Authentication Endpoint
const BASE_URL = Environment.getCurrent().endpoints.auth;

/**
 * Iniciar sesión
 * @param {object} data { user, password }
 * @return {any} promise
 */
const login = (loginData) => {
  const clientId = Environment.getCurrent().clientId;

  const authData = `grant_type=password&username=${encodeURIComponent(loginData.userName)}&password=${encodeURIComponent(loginData.password)}&client_id=${clientId}`;

  let userLang = navigator.language || navigator.userLanguage;
  let croppedLang = userLang.split('-')[0];

  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
    'Accept-Language': croppedLang
  };

  // NOTA: Desde el Login se envía siempre en TRUE useRefreshTokens
  return axios.post(BASE_URL, authData, { headers })
    .then(({ data }) => {
      // Guardar información de autenticación en LocalStorage (tokens, fecha, etc.)
      if (loginData.useRefreshTokens) {
        localStorage.setItem('ls.authorizationData', JSON.stringify({
          token: data.access_token,
          refreshToken: data.refresh_token,
          userName: data.userName,
          useRefreshTokens: true,
          expirationDate: moment().add(data.expires_in, 'seconds')
        }));
      } else {
        localStorage.setItem('ls.authorizationData', JSON.stringify({
          token: data.access_token,
          refreshToken: '',
          userName: data.userName,
          useRefreshTokens: false,
          expirationDate: moment().add(data.expires_in, 'seconds')
        }));
      }

      if (loginData.keepSession) {
        localStorage.setItem('ls.credentials', JSON.stringify({
          userName: loginData.userName,
          password: loginData.password
        }));
      }

      authentication.isAuth = true;
      return data;
    });
};

/**
 * Cerrar sesión
 */
const logout = () => {
  authentication.isAuth = false;
  const currentEnvironment = Environment.getCurrent();
  let URL = currentEnvironment.domain;
  window.location.href = `${URL.substring(0, URL.length - 2)}talentry/#/login`;
};

/** 
 * Limpiar LocalStorage
 */
const clearStorage = () => {
  localStorage.clear();
  localStorage.removeItem('ls.authorizationData');
  localStorage.removeItem('ls.infoUsuario');
};

export const AuthService = {
  login,
  logout,
  clearStorage,
  authentication
};